import {IconButton, Tooltip, Portal} from "@chakra-ui/react";
import {useColorMode, useColorModeValue} from "./ui/color-mode";
import { FiSun, FiMoon } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'

const ColorModeToggle = () => {
    const { colorMode, toggleColorMode } = useColorMode()
    const { t } = useTranslation()
    const location = useLocation()

    const forcedLightModeRoutes = useMemo(() => [
        '/r/', '/reservation-confirmation/', '/rate/',
        '/', '/explore', '/pricing', '/login', '/register',
        '/privacy', '/terms', '/cookies', '/about',
        // /login and /register already cover /login/{barber,customer} + /register/{barber,customer} via startsWith
    ], [])
    const isOnForcedLightModePage = useMemo(
        () => forcedLightModeRoutes.some(route =>
            route === '/' ? location.pathname === '/' : location.pathname.startsWith(route)
        ),
        [forcedLightModeRoutes, location.pathname]
    )

    const hoverBg = useColorModeValue('gray.100', 'gray.700')
    const iconColor = useColorModeValue('gray.600', 'gray.400')

    if (isOnForcedLightModePage) {
        return null
    }

    const SwitchIcon = colorMode === 'light' ? FiMoon : FiSun
    const nextMode = colorMode === 'light' ? t('colorMode.dark') : t('colorMode.light')

    return (
        <Tooltip.Root>
            <Tooltip.Trigger asChild>
                <IconButton
                    aria-label={t('colorMode.toggle')}
                    onClick={toggleColorMode}
                    variant="ghost"
                    size="md"
                    color={iconColor}
                    _hover={{ bg: hoverBg }}
                >
                    <SwitchIcon />
                </IconButton>
            </Tooltip.Trigger>
            <Portal>
                <Tooltip.Positioner>
                    <Tooltip.Content>
                        <Tooltip.Arrow><Tooltip.ArrowTip /></Tooltip.Arrow>
                        {nextMode}
                    </Tooltip.Content>
                </Tooltip.Positioner>
            </Portal>
        </Tooltip.Root>
    )
}

export default ColorModeToggle
